export const USERNAME_TYPES = {
	EMAIL: 'email',
	MOBILE: 'mobile',
};
